// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1p-Bb","header":"ClearentDisclaimer_header__3wwEm","inner":"ClearentDisclaimer_inner__29N5_"};